function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".events-lanyard_svg__cls-1{fill:#000;stroke-width:0}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "events-lanyard_svg__cls-1",
  d: "M52.5 63.46c-3.47 0-6.18-2.69-6.18-6.11s2.71-6.05 6.18-6.05 6.18 2.66 6.18 6.05-2.71 6.11-6.18 6.11zm0-9.66c-2.1 0-3.68 1.53-3.68 3.55s1.58 3.61 3.68 3.61 3.68-1.59 3.68-3.61-1.62-3.55-3.68-3.55zM58.66 34.27H46.34c-10.55 0-20.18-5.79-25.16-15.12l2.21-1.18a25.957 25.957 0 0022.95 13.79h12.32c9.62 0 18.41-5.29 22.95-13.79l2.21 1.18a28.458 28.458 0 01-25.16 15.12zM70.54 81.29c-2.85-8.39-8.26-13.61-14.12-13.61h-7.84c-5.86 0-11.27 5.21-14.12 13.61l-2.37-.8c3.2-9.44 9.52-15.31 16.49-15.31h7.84c6.97 0 13.29 5.86 16.49 15.31l-2.37.8z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "events-lanyard_svg__cls-1",
  d: "M66.85 87.69h-28.7c-3.38 0-6.12-2.75-6.12-6.12V49.41c0-3.38 2.75-6.12 6.12-6.12h28.7c3.38 0 6.12 2.75 6.12 6.12v32.16c0 3.38-2.75 6.12-6.12 6.12zm-28.7-41.91c-2 0-3.62 1.63-3.62 3.62v32.16c0 2 1.62 3.62 3.62 3.62h28.7c2 0 3.62-1.63 3.62-3.62V49.4c0-2-1.62-3.62-3.62-3.62h-28.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "events-lanyard_svg__cls-1",
  d: "M51.25 33.32h2.5v11.22h-2.5zM40.8 77.66h2.5v8.78h-2.5zM61.7 77.66h2.5v8.78h-2.5z"
});

function SvgEventsLanyard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "events-lanyard_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 105 105"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgEventsLanyard;